module.exports = __webpack_public_path__ + "img/TV.aaf8baef.svg";